<template>
  <!-- HEADER -->
  <div class="d-flex align-center ga-4 mb-4">
    <h2 class="font-weight-bold">Relación Opción Perfil - {{ descPerfilId }}</h2>
    <v-divider class="mx-4" inset vertical></v-divider>
    <!-- Links -->
    <v-tooltip location="bottom" color="white">
      <template v-slot:activator="{ props }">
        <v-icon @click="editItemValores(1)" color="orange" v-bind="props"
          >mdi-link</v-icon
        >
      </template>
      <span>Links</span>
    </v-tooltip>
    <v-divider class="mx-4" inset vertical></v-divider>
    <!-- Roles -->
    <v-tooltip location="bottom" color="white">
      <template v-slot:activator="{ props }">
        <v-icon @click="editItemValores(2)" color="blue" v-bind="props"
          >mdi-briefcase-account</v-icon
        >
      </template>
      <span>Roles</span>
    </v-tooltip>
  </div>
  <!-- Tablero de control -->
  <v-data-table
    v-model="selected"
    v-model:page="itemsPerPage"
    :headers="headers"
    :items="desserts"
    :search="search"
    item-value="ProcesoId"
    show-select
    return-object
    height="550px"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <!-- Campos -->
        <v-dialog v-model="dialogframecreate" persistent max-width="1500px">
          <template v-if="param1[1] == '1'" v-slot:activator="{ props }">
            <v-btn
              color="green"
              icon="mdi-plus"
              size="x-large"
              dark
              class="mb-2"
              v-bind="props"
              @click="CargueCombo"
            >
            </v-btn>
          </template>
          <v-card>
            <v-toolbar dark color="red-darken-4">
              <v-toolbar-title
                ><v-icon left>{{ iconTitle }}</v-icon> {{ formTitle }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn
                  class="d-none d-md-block"
                  dark
                  text
                  @click="
                    dialogframecreate = false;
                    editedItem = null;
                    editedIndex = -1;
                  "
                  >Cerrar</v-btn
                >
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <proceso-registro
                v-if="dialogframecreate"
                :infoedit="editedItem"
                :perfilId="perfilId"
                v-bind:page="dialogframecreate"
                v-on:update:page="dialogframecreate = $event"
                v-bind:Exito="respuestapostput"
                v-on:update:Exito="respuestapostput = $event"
                v-bind:componenteview="componenteview"
                v-on:update:componenteview="componenteview = $event"
                v-bind:pageiframe="dialogframeboton"
                v-on:update:pageiframe="dialogframeboton = $event"
                v-bind:titledialogbtn="titledialogbtn"
                v-on:update:titledialogbtn="titledialogbtn = $event"
                v-bind:iconodialogbtn="iconodialogbtn"
                v-on:update:iconodialogbtn="iconodialogbtn = $event"
                :infopermisos="param1"
                :editedIndex="editedIndex"
              ></proceso-registro>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-divider v-if="param1[1] == '1'" class="mx-4" inset vertical></v-divider>
        <!-- Eliminación -->
        <v-btn
          v-if="param1[3] == '1'"
          color="red"
          icon="mdi-delete"
          dark
          class="mb-2"
          @click="Eliminar"
        >
        </v-btn>
        <v-divider v-if="param1[3] == '1'" class="mx-4" inset vertical></v-divider>
        <!-- Filtros -->
        <v-dialog v-model="dialogframe" persistent max-width="1000px">
          <template v-slot:activator="{ props }">
            <v-btn
              color="cyan"
              icon="mdi-filter-menu"
              dark
              class="mb-2"
              v-bind="props"
              @click="CargueCombo"
            >
            </v-btn>
          </template>
          <v-card>
            <v-toolbar dark color="red-darken-4">
              <v-toolbar-title
                ><v-icon left>mdi-filter-menu</v-icon> Filtros
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn class="d-none d-md-block" dark text @click="reset">Limpiar</v-btn>
                <v-btn class="d-none d-md-block" dark text @click="ValidateCampos"
                  >Consultar</v-btn
                >
                <v-btn class="d-none d-md-block" dark text @click="dialogframe = false"
                  >Cerrar</v-btn
                >
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <v-form ref="form" autocomplete="off">
                <v-row v-for="(datos, i) in modelfiltro" :key="i">
                  <!-- Filtro -->
                  <v-col cols="6">
                    <v-autocomplete
                      v-model="datos.filtro"
                      :items="items"
                      item-title="descripcion"
                      item-value="filtro"
                      label="Tipo de filtro:"
                      :clearable="datos.clear"
                      :readonly="datos.lectura"
                    ></v-autocomplete>
                  </v-col>

                  <!-- Array User  -->
                  <v-col v-if="i == 0" cols="6">
                    <v-autocomplete
                      v-model="datos.contenido"
                      :items="
                        ArrayRoles.map((x) => ({
                          ...x,
                          Id: String(x.Id),
                        }))
                      "
                      :item-title="
                        (ArrayRoles) => ArrayRoles.Id + '-' + ArrayRoles.NombrePerfil
                      "
                      item-value="Id"
                      :label="datos.label"
                      dense
                      :clearable="datos.clear"
                      :readonly="datos.lectura"
                    >
                    </v-autocomplete>
                  </v-col>

                  <!-- Array Roles  -->
                  <v-col v-else-if="i == 1" cols="6">
                    <v-autocomplete
                      v-model="datos.contenido"
                      :items="
                        ArrayRoles.map((x) => ({
                          ...x,
                          Id: String(x.Id),
                        }))
                      "
                      :item-title="
                        (ArrayRoles) => ArrayRoles.Id + '-' + ArrayRoles.NombrePerfil
                      "
                      item-value="Id"
                      :label="datos.label"
                      dense
                      clearable
                    >
                    </v-autocomplete>
                  </v-col>

                  <!-- Array Links  -->
                  <v-col v-else-if="i == 2" cols="6">
                    <v-autocomplete
                      v-model="datos.contenido"
                      :items="
                        ArrayLinks.map((x) => ({
                          ...x,
                          IDLink: String(x.IDLink),
                        }))
                      "
                      :item-title="
                        (ArrayLinks) => ArrayLinks.IDLink + '-' + ArrayLinks.Descripcion
                      "
                      item-value="IDLink"
                      :label="datos.label"
                      dense
                      clearable
                    >
                    </v-autocomplete>
                  </v-col>

                  <v-col v-else cols="6">
                    <v-text-field
                      v-model="datos.contenido"
                      :label="datos.label"
                      :clearable="datos.clear"
                      :readonly="datos.lectura"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <!-- Buscador -->
        <v-text-field
          v-model="search"
          append-inner-icon="mdi-magnify"
          label="Buscar..."
          single-line
          variant="underlined"
          hide-details
        ></v-text-field>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <div class="text-center">
        <v-row>
          <!-- Modificación  -->
          <v-tooltip
            v-if="param1[2] == '1' || param1[0] == '1'"
            location="bottom"
            color="white"
          >
            <template v-slot:activator="{ props }">
              <v-icon color="#05AD58" @click="editItem(item.raw, 0)" v-bind="props">{{
                param1[2] == "1" && param1[0] == "0" ? "mdi-pencil" : "mdi-eye"
              }}</v-icon>
            </template>
            <span>{{
              param1[2] == "1" && param1[0] == "0" ? "Modificar" : "Consultar"
            }}</span>
          </v-tooltip>
        </v-row>
      </div>
    </template>
    <template v-slot:item.DescUsuario="{ item }">
      {{ item.raw.Usuario + " - " + item.raw.DescUsuario }}
    </template>
    <template v-slot:item.Estado="{ item }">
      <div class="text-center">
        <v-chip :color="item.raw.Estado ? 'green' : 'red'" variant="flat">
          {{ item.raw.Estado ? "Activo" : "Inactivo" }}
        </v-chip>
      </div>
    </template>
  </v-data-table>
  <!-- Linea de progreso -->
  <div class="d-flex align-center flex-column">
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img class="mx-auto" :width="5" src="/static/iconos/logo2.png"></v-img>
          </v-toolbar>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Registro from "@/views/TCI/Seguridad/RelacionOpcionPerfil/RelacionOpcionPerfilRegistro.vue";
import {
  getConsultAll,
  Delete,
} from "@/views/TCI/Seguridad/RelacionOpcionPerfil/RelacionOpcionPerfilService";
import { getConsultAllList } from "@/views/TCI/Seguridad/Links/LinksServices";

export default {
  name: "RelacionOpcionPerfil",
  props: {
    infopermisos: {
      type: String,
      default: "0111",
      Description: "Información de permisos",
    },
    pageiframe: {
      type: Boolean,
      default: false,
      Description: "Saber desde donde se llama la página",
    },
  },
  components: {
    "proceso-registro": Registro,
  },
  data() {
    return {
      perfilId: null,
      descPerfilId: null,
      itemsPerPage: 1,
      selected: [],
      search: "",
      respuestapostput: "",
      consult: false,
      editedItem: null,
      editedIndex: -1,
      progreso: false,
      dialogframe: false,
      dialogframecreate: false,
      dialogframeboton: false,
      iconodialogbtn: "",
      titledialogbtn: "",
      componenteview: 0,
      infoitem: [],
      items: [
        {
          filtro: "=",
          descripcion: "Igual a",
        },
        {
          filtro: "LIKE",
          descripcion: "Similar a",
        },
        {
          filtro: ">=",
          descripcion: "Mayor igual a",
        },
        {
          filtro: "<=",
          descripcion: "Menor igual a",
        },
      ],
      modelfiltro: [
        {
          campo: "Id",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Perfil Id:",
        },
        {
          campo: "SubPerfilId",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Sub Perfil Id:",
        },
        {
          campo: "LinkId",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Link:",
        },
      ],
      headers: [
        {
          title: "Acciones",
          key: "actions",
          sortable: false,
        },
        {
          title: "Consecutivo",
          key: "Consecutivo",
        },
        {
          title: "Perfil",
          key: "DescPerfilId",
        },
        {
          title: "Tipo de Perfil",
          key: "DescTipo",
        },
        {
          title: "Sub Perfil",
          key: "DescSubPerfilId",
        },
        {
          title: "Link",
          key: "DescLinkId",
        },
      ],
      desserts: [],
      ArrayPerfil: [],
      ArrayLinks: [],
      param1: [],
      busquedacompleta: false,
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Crear Registro"
        : this.param1[2] == "1" && this.param1[0] == "0"
        ? "Actualizar registro"
        : "Consultar registro";
    },
    iconTitle() {
      return this.editedIndex === -1
        ? "mdi-plus"
        : this.param1[2] == "1" && this.param1[0] == "0"
        ? "mdi-pencil"
        : "mdi-eye";
    },
  },
  watch: {
    dialogframecreate(val) {
      if (!val && this.respuestapostput == "Exito" && this.consult) {
        this.respuestapostput = null;
        this.ValidateCampos();
        this.itemsPerPage = 1;
      }
    },
  },
  methods: {
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////

    // Validación de campos
    async ValidateCampos() {
      var validate = false;
      this.consult = validate;
      this.busquedacompleta = false;
      for (var i = 0; i < this.modelfiltro.length; i++) {
        if (
          (this.modelfiltro[i].filtro == "" || this.modelfiltro[i].filtro == null) &&
          this.modelfiltro[i].contenido != "" &&
          this.modelfiltro[i].contenido != null
        ) {
          validate = true;
        } else if (
          (this.modelfiltro[i].contenido == "" ||
            this.modelfiltro[i].contenido == null) &&
          this.modelfiltro[i].filtro != "" &&
          this.modelfiltro[i].filtro != null
        ) {
          validate = true;
        } else if (
          (this.modelfiltro[i].contenido != "" ||
            this.modelfiltro[i].contenido != null) &&
          this.modelfiltro[i].filtro != "" &&
          this.modelfiltro[i].filtro != null
        ) {
          this.busquedacompleta = true;
        }
      }
      // Consultas a Ejecutar
      if (!validate) {
        this.consult = true;
        this.getConsultData();
      } else {
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html:
            " Hay campos que se encuentran incompletos o no contiene el respecitivo filtro.",
        });
      }
    },

    // Consulta Tablero
    async getConsultData() {
      this.desserts = [];
      this.selected = [];
      this.progreso = true;
      var data = {
        filtrado: this.modelfiltro,
        busquedacompleta: this.busquedacompleta,
      };
      try {
        const result = await getConsultAll(data);
        this.desserts = result;
      } catch (error) {
        console.error(error);
        const registro = error.data || {};
        const mensajeerror =
          registro.Mensaje || registro.ExceptionMessage || JSON.stringify(registro);

        if (error.status === 404) {
          this.$swal({
            icon: "warning",
            title: "Consulta inexistente.",
            html: mensajeerror,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Error al consultar",
            html:
              "El servidor ha encontrado la siguiente condición inesperada:<br><small><code>" +
              mensajeerror +
              "</code></small>",
          });
        }
      } finally {
        this.progreso = false;
        this.dialogframe = false;
      }
    },

    // Item editar
    editItemValores(data) {
      if (data == 1) {
        this.$router.push({
          name: "Links",
        });
      } else if (data == 2) {
        this.$router.push({
          name: "Roles",
        });
      }
    },

    // Item editar
    editItem(item, iconoelegido) {
      this.componenteview = iconoelegido;
      this.infoitem = item;
      switch (iconoelegido) {
        case 0:
          this.editedIndex = this.desserts.indexOf(item);
          this.editedItem = Object.assign({}, item);
          this.dialogframecreate = true;
          break;
      }
    },

    // Confirmación de eliminación
    Eliminar() {
      if (this.selected.length != 0 && this.selected != null) {
        this.$swal({
          icon: "question",
          title: "Eliminar Información",
          html:
            "¿Está seguro que desea eliminar la información seleccionada?<br>Esta acción no se puede deshacer luego de confirmarla.",
          confirmButtonText: "Sí",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
        }).then((result) => {
          if (result.isConfirmed) {
            this.getDelete();
          }
        });
      } else {
        this.$swal({
          icon: "info",
          title: "Seleccione la fila a eliminar",
          html:
            "Lo sentimos, debe seleccionar la celda o celdas para eliminar el registro.",
        });
      }
    },

    // Consulta las eliminaciones
    async getDelete() {
      this.progreso = true;
      try {
        const result = await Delete(this.selected);
        if (result === "Exito") {
          this.$swal({
            icon: "success",
            title: "Información Eliminada",
            html: "La información se ha eliminado correctamente.",
          });
          this.getConsultData();
          this.selected = [];
        } else {
          this.$swal({
            icon: "error",
            title: "Error al eliminar los datos",
            html: result.toString(),
          });
        }
      } catch (error) {
        console.error(error);
        const registro = error.data || {};
        const mensajeerror =
          registro.Mensaje || registro.ExceptionMessage || JSON.stringify(registro);

        if (error.status === 404) {
          this.$swal({
            icon: "warning",
            title: "Consulta inexistente.",
            html: mensajeerror,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Error al consultar",
            html:
              "El servidor ha encontrado la siguiente condición inesperada:<br><small><code>" +
              mensajeerror +
              "</code></small>",
          });
        }
      } finally {
        this.progreso = false;
      }
    },

    // Consulta Url
    async getUrl() {
      this.ArrayLinks = [];
      const result = await getConsultAllList();
      this.ArrayLinks = result;
    },
    ///////////////////////////////////////////////// Métodos de acciones ///////////////////////////////////////////
    // Cerrar combos
    CerrarCombos() {
      this.dialogframeboton = false;
    },

    // Limpiar campos
    reset() {
      this.busquedacompleta = false;
      this.$refs.form.reset();

      if (this.$route.query) {
        this.perfilId = this.$route.query.perfilId;
        this.modelfiltro[0].contenido = this.perfilId;
        this.modelfiltro[0].filtro = "=";
        this.modelfiltro[0].lectura = true;
        this.modelfiltro[0].clear = false;

        this.perfilId = parseInt(this.perfilId);
      }
    },

    // Cargue Combo
    CargueCombo() {
      var Perfil = this.$store.getters.MRol;
      this.ArrayRoles = Perfil;

      this.getUrl();
    },

    // Busca los parametros de la pagina
    parametrospaginas() {
      var page = this.$store.getters.userperfil.paginainfo;
      if (page.param1) {
        var splitparam1 = page.param1.split("");
        this.param1 = splitparam1;
        this.ValidateCampos();
      }
    },

    // Parametros Iframe
    parametrosiframe() {
      var splitparam1 = this.infopermisos.split("");
      this.param1 = splitparam1;
      this.ValidateCampos();
    },
  },
  mounted() {
    if (this.$route.query) {
      this.perfilId = this.$route.query.perfilId;
      this.descPerfilId = this.$route.query.descPerfilId;
      this.modelfiltro[0].contenido = this.perfilId;
      this.modelfiltro[0].filtro = "=";
      this.modelfiltro[0].lectura = true;
      this.modelfiltro[0].clear = false;

      this.perfilId = parseInt(this.perfilId);
    }

    if (!this.pageiframe) {
      this.parametrospaginas();
    } else {
      this.parametrosiframe();
    }
  },
};
</script>
